/**
 * Spinner to display while a route is loading.
 */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import PageRoot from "./page-root.tsx";

type Props = Record<any, any> & {
    // An optional prop to override the page template used for the spinner.
    // Will default to DefaultPageTemplate in PageRoot.
    template?: React.ComponentType<{children: React.ReactNode}>;
};

/**
 * Spinner component to display while a route is loading.
 *
 * Use this with your Loadable or Loadable.Map `loading` prop.
 */
const RouteLoadSpinner = (props: Props): React.ReactElement => (
    <PageRoot template={props.template}>
        <View style={styles.spinnerWrapper}>
            <CircularSpinner />
        </View>
    </PageRoot>
);

const styles = StyleSheet.create({
    spinnerWrapper: {
        alignItems: "center",
        // Add some padding so that the spinner isn't stuck to the header or footer.
        margin: `${spacing.xxLarge_48}px ${spacing.small_12}px`,
    },
});

export default RouteLoadSpinner;
